// import Screen from "@/src/components/Screen";
import { Card } from "@/src/components/shad/card";
import SideHistory from "./components/SideHistory";
import { Outlet } from "react-router-dom";

const Funding = () => {
  return (
    <>
      <div className="mt-5 grid md:grid-cols-2 gap-5">
        <div>
          <Outlet />
        </div>
        <div className="hidden md:flex flex-col gap-5">
          <Card className="p-0">
            <SideHistory />
          </Card>
        </div>
      </div>
    </>
  );
};

export default Funding;
